/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './navigator.tpl.html';

angular
  .module('batch.navigator', ['stores.picker.basicbatch'])
  /**
   * Controller for the batch.navigator template.
   */
  .controller(
    'BatchNavigatorCtrl',
    function ($scope, $filter, $rootScope, batchUtils, BasicBatchPickerStore, BATCH_RESULT_TABS) {
      $scope.orderListByData = {
        alphaAsc: {
          order: 1,
          title: 'ALPHABETICALLY_ASC',
          expression: 'name',
          reverse: false,
          key: 'alphaAsc'
        },
        alphaDesc: {
          order: 2,
          title: 'ALPHABETICALLY_DESC',
          expression: 'name',
          reverse: true,
          key: 'alphaDesc'
        },
        countAsc: {
          order: 3,
          title: 'COUNT_ASC',
          expression: 'total',
          reverse: false,
          key: 'countAsc'
        },
        countDesc: {
          order: 4,
          title: 'COUNT_DESC',
          expression: 'total',
          reverse: true,
          key: 'countDesc'
        }
      };

      $scope.resultTabs = BATCH_RESULT_TABS;
      $scope.$parent.currentTab = $scope.resultTabs.RECORDS;

      $scope.showMetadata = true;
      $scope.currentOrderBy = $filter('i18n')($scope.orderListByData.countDesc.title);
      $scope.$parent.orderBy = $scope.orderListByData.countDesc.expression;
      $scope.$parent.reverse = $scope.orderListByData.countDesc.reverse;
      $scope.showLoadingMask = $rootScope.showLoadingMask;

      $rootScope.showLoadingMask = true;
      $scope.pickerStore = new BasicBatchPickerStore();
      $scope.pickerStore.getBatch(batchUtils.currentBatch.batchId).finally(() => {
        $rootScope.showLoadingMask = false;
      });

      /**
       * Function to determine if item is selected.
       * @param {Number} tab - The tab to check if its the current one.
       * @returns {Boolean} - Flag if the item is selected or not.
       */
      $scope.isTabSelected = function (tab) {
        return $scope.$parent.currentTab === tab;
      };

      /**
       * Function to show the correct content for the selected tab.
       * @param {Number} tab - The tab to set to the current tab.
       */
      $scope.showTab = function (tab) {
        $scope.$parent.currentTab = tab;
      };

      /**
       * Clear the typeQuery value if it exists.
       */
      $scope.clearQuery = function () {
        if ($scope.$parent.currentTab === $scope.resultTabs.RECORDS && $scope.$parent.typeQuery.records) {
          $scope.$parent.typeQuery.records = '';
        } else if ($scope.$parent.currentTab === $scope.resultTabs.METADATA && $scope.$parent.typeQuery.metadata) {
          $scope.$parent.typeQuery.metadata = '';
        }
      };

      /*
       * Determines if the typeQuery contains text for the current tab
       *
       * @returns {Boolean} - Flag if the current tab has type query text or not.
       */
      $scope.hasQueryText = function () {
        return $scope.$parent.currentTab === $scope.resultTabs.METADATA
          ? $scope.$parent.typeQuery.metadata !== ''
          : $scope.$parent.typeQuery.records !== '';
      };

      /**
       * Order the batch details list. The orderBy and reverse variables are being used to sort list.
       * currentOrderBy is used for the current button title.
       *
       * @param {string} orderByKey - The key of object to get.
       */
      $scope.orderListBy = function (orderByKey) {
        var orderByObj = $scope.getOrderByObject(orderByKey);
        $scope.currentOrderBy = $filter('i18n')(orderByObj.title);
        $scope.$parent.orderBy = orderByObj.expression;
        $scope.$parent.reverse = orderByObj.reverse;
      };

      /**
       * Get the order by object for given key.
       *
       * @param {string} key - The key of object to get.
       * @returns {Object} The order by option object.
       */
      $scope.getOrderByObject = function (key) {
        return $scope.orderListByData[key];
      };

      $scope.$watch(
        function () {
          return batchUtils.requestsInProgress;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            $rootScope.showLoadingMask = newVal > 0;
          }
        }
      );
    }
  );
